import { hbs } from 'ember-cli-htmlbars';
export default hbs("<img\n  src={{@imgPath}}\n  class=\"nw-engine\"\n  alt=\"\"\n  role=\"presentation\"\n  ...attributes\n/>")